module.exports = __webpack_public_path__ + "img/FR15208.6d15ed0f.png";